var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { copyArray2D } from './util/deepCopy';
import { ObcFrame } from './obc-frame';
var Frame = (function () {
    function Frame(obj) {
        if (obj === void 0) { obj = null; }
        this.timestamp = 0;
        this.readings = Array(Frame.NUM_SENSORS).fill([1, 0, 0, 0]);
        this.accelerations = undefined;
        this.angularVelocities = undefined;
        if (obj) {
            this.timestamp = obj.timestamp;
            this.readings = copyArray2D(obj.readings);
            if (obj.accelerations) {
                this.accelerations = copyArray2D(obj.accelerations);
            }
            if (obj.angularVelocities) {
                this.angularVelocities = copyArray2D(obj.angularVelocities);
            }
        }
    }
    Frame.prototype.clone = function () {
        var frame = new Frame();
        frame.timestamp = this.timestamp;
        frame.readings = copyArray2D(this.readings);
        if (this.accelerations) {
            frame.accelerations = copyArray2D(this.accelerations);
        }
        if (this.angularVelocities) {
            frame.angularVelocities = copyArray2D(this.angularVelocities);
        }
        return frame;
    };
    Frame.prototype.build = function (shirt, pant) {
        this.timestamp = shirt.timestamp;
        this.readings = copyArray2D(__spreadArray(__spreadArray([], shirt.readings, true), pant.readings, true));
        if (shirt.accelerations || pant.accelerations) {
            this.accelerations = copyArray2D(__spreadArray(__spreadArray([], (shirt.accelerations ? shirt.accelerations : Array(ObcFrame.NUM_SENSORS).fill([0, 0, 0])), true), (pant.accelerations ? pant.accelerations : Array(ObcFrame.NUM_SENSORS).fill([0, 0, 0])), true));
        }
        if (shirt.angularVelocities || pant.angularVelocities) {
            this.angularVelocities = copyArray2D(__spreadArray(__spreadArray([], (shirt.angularVelocities ? shirt.angularVelocities : Array(ObcFrame.NUM_SENSORS).fill([0, 0, 0])), true), (pant.angularVelocities ? pant.angularVelocities : Array(ObcFrame.NUM_SENSORS).fill([0, 0, 0])), true));
        }
    };
    Frame.NUM_SENSORS = 2 * ObcFrame.NUM_SENSORS;
    return Frame;
}());
export { Frame };
//# sourceMappingURL=frame.js.map